import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Model} from '../../../Models/Model';
import {concat, Observable, of, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {ModelService} from '../../../Services/model.service';
import {CollectionService} from '../../../Services/collection.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {HttpParams} from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-archive-model-view',
  templateUrl: './archive-model-view.component.html',
  styleUrls: ['./archive-model-view.component.scss']
})
export class ArchiveModelViewComponent implements OnInit {
  public grid: Grid;
  public modelId: number;
  public selectedModel: Model;
  public modelName: string;
  public models: Observable<Model[]>;
  public modelinput$ = new Subject<string>();
  public modelLoading = false;

  @ViewChild('collectionRowDetail', {static: false}) collectionRowDetail: any;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(private router: Router, private modelService: ModelService, private collectionService: CollectionService, private broadcastService: BroadcastService, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.model.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.code',
          prop: 'code',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.model.status',
          prop: 'status',
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.model.attach_products',
          prop: 'productCount',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.model.collection',
          prop: 'collection.name',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.modelId = row.id;
                this.modelName = row.name.bold();
                this.readdModal.show();

                // return this.router.navigateByUrl('back-office/property/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.modelService,
      rememberURL: this.router.url,
      method: 'getModel',
      defaultSort: 'name',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'collection_id',
          type: 'ng-select',
          label: 'doctrine.attributes.collection',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.collectionService, 'getCollection', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
      archive: true,
    };

  }

  private loadModel() {
    const params = new HttpParams();
    this.models = concat(
      of([]), // default items
      this.modelinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(query => query && query.length > 2),
        tap(() => this.modelLoading = true),
        switchMap((term) => this.modelService.getModelReplace(params.set('query', term)).pipe(
          catchError(() => of([])), // empty list on error
          tap((res) => {
            this.modelLoading = false;
          })
        ))
      )
    );
  }


  public readd() {
    this.modelService.readdModel(this.modelId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getModel');
      this.readdModal.hide();
    });
  }
}
